import { render, staticRenderFns } from "./DeleteIconButton.vue?vue&type=template&id=0d4f4de0&"
import script from "./DeleteIconButton.vue?vue&type=script&lang=js&"
export * from "./DeleteIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports